import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/addWeeks/index.js';

var require$$9 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$9 as default };
